// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  list-style-type: none;
  padding: 0;
  margin-top: 10px;
  flex: 1 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cfcfcf #1a1a1a;
}

.menu::-webkit-scrollbar {
  width: 6px;
}

.menu::-webkit-scrollbar-track {
  background: #111;
}

.menu::-webkit-scrollbar-thumb {
  background: #d6d6d6;
  border-radius: 8px;
}

.menu::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}

.menu::-webkit-scrollbar-thumb:active {
  background: #e6e6e6;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  margin: 8px;
  transition: background-color 0.3s ease;
}

.menu-item .icon,
.menu-item .label {
  color: #ffffff;
  transition: color 0.3s ease;
  text-align: center;
  font-size: 10px;
}

.menu-item:hover {
  margin: 8px;
  border-radius: 10px;
  background-color: #0B51C5;
}

.menu-item:hover .icon,
.menu-item:hover .label {
  color: #ffffff;
}

.menu-item.active {
  background-color: #007bff;
  border-radius: 10px;
}

.menu-item.active .icon,
.menu-item.active .label {
  color: #ffffff;
}

.menu-item.active:hover {
  background-color: #007bff;
}

.menu-item.active:hover .icon,
.menu-item.active:hover .label {
  color: #ffffff;
}

.subsidebar_icon svg {
  color: white;
  stroke: #FFFFFF;
  transition: color 0.3s ease, stroke 0.3s ease;
}

.subsidebar_icon:hover svg {
  color: #FFFFFF;
  stroke: #FFFFFF;
}

.subsidebar_icon.active svg {
  color: #ffffff;
  stroke: #ffffff;
}

.subsidebar_icon.active:hover svg {
  color: #ffffff;
  stroke: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Sidebar/styles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".menu {\n  list-style-type: none;\n  padding: 0;\n  margin-top: 10px;\n  flex: 1;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #cfcfcf #1a1a1a;\n}\n\n.menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.menu::-webkit-scrollbar-track {\n  background: #111;\n}\n\n.menu::-webkit-scrollbar-thumb {\n  background: #d6d6d6;\n  border-radius: 8px;\n}\n\n.menu::-webkit-scrollbar-thumb:hover {\n  background: #ffffff;\n}\n\n.menu::-webkit-scrollbar-thumb:active {\n  background: #e6e6e6;\n}\n\n.menu-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  cursor: pointer;\n  margin: 8px;\n  transition: background-color 0.3s ease;\n}\n\n.menu-item .icon,\n.menu-item .label {\n  color: #ffffff;\n  transition: color 0.3s ease;\n  text-align: center;\n  font-size: 10px;\n}\n\n.menu-item:hover {\n  margin: 8px;\n  border-radius: 10px;\n  background-color: #0B51C5;\n}\n\n.menu-item:hover .icon,\n.menu-item:hover .label {\n  color: #ffffff;\n}\n\n.menu-item.active {\n  background-color: #007bff;\n  border-radius: 10px;\n}\n\n.menu-item.active .icon,\n.menu-item.active .label {\n  color: #ffffff;\n}\n\n.menu-item.active:hover {\n  background-color: #007bff;\n}\n\n.menu-item.active:hover .icon,\n.menu-item.active:hover .label {\n  color: #ffffff;\n}\n\n.subsidebar_icon svg {\n  color: white;\n  stroke: #FFFFFF;\n  transition: color 0.3s ease, stroke 0.3s ease;\n}\n\n.subsidebar_icon:hover svg {\n  color: #FFFFFF;\n  stroke: #FFFFFF;\n}\n\n.subsidebar_icon.active svg {\n  color: #ffffff;\n  stroke: #ffffff;\n}\n\n.subsidebar_icon.active:hover svg {\n  color: #ffffff;\n  stroke: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
